module.exports = __webpack_public_path__ + "img/ivywayfacebook_QR.7cfc1d40.webp";